import { APP_SCORE_COLORS } from '@/constants/config';
import type { TScoreColorScale } from '../types';

/**
 * Returns the 4-level score color scale used by ScoreCircle rendering logic.
 */
export const getScoreColorScale = (): TScoreColorScale => ({
  1: APP_SCORE_COLORS.L1,
  2: APP_SCORE_COLORS.L2,
  3: APP_SCORE_COLORS.L3,
  4: APP_SCORE_COLORS.L4,
});
